"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    container: {
        marginTop: 10,
        display: 'flex'
    },
    url: {
        display: 'block',
        width: '100%',
        fontSize: 12,
        borderBottom: `1px solid ${globalStyle_1.default.grey4}`,
        paddingBottom: 7,
        '&:focus': {
            outline: 'none',
            borderBottomColor: globalStyle_1.default.indigo3
        }
    },
    saveBtn: {
        marginLeft: 10
    }
};
//# sourceMappingURL=urlSelector.style.js.map